import defaultStyles from "fond/draw/defaultStyles";
import { MapboxStyleLayer } from "fond/types";

/**
 * The MapboxDraw theme extended to include styles specific for planner projects
 * when modifying hub features.
 */
const modifiedDefaults: MapboxStyleLayer[] = defaultStyles.map((style) => {
  if (style.id === "gl-draw-point-stroke-active") {
    return {
      ...style,
      paint: {
        ...style.paint,
        "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 16],
        "circle-color": "#FFF000",
      },
    } as mapboxgl.CircleLayer;
  }

  if (["gl-draw-point-active", "gl-draw-point-inactive"].includes(style.id)) {
    return {
      ...style,
      type: "symbol",
      layout: {
        "text-field": "\uE8C8",
        "text-anchor": "bottom",
        "text-justify": "center",
        "text-allow-overlap": true,
        "text-ignore-placement": true,
        "text-font": ["fontello Regular"],
        "text-offset": [0.05, 0],
        "text-padding": 0,
        "text-rotate": 0.01,
        "text-size": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 12],
        "text-line-height": -0.45,
      },
      paint: {
        "text-opacity": 1,
        "text-translate": [-0.6, 0.1],
        "text-halo-width": 1,
        "text-halo-color": "#ffffff",
      },
    } as mapboxgl.SymbolLayer;
  }

  return style;
});

const styles: MapboxStyleLayer[] = [
  ...modifiedDefaults,
  {
    id: "gl-draw-point-feeder-hub",
    type: "symbol",
    filter: ["all", ["==", "$type", "Point"], ["==", "meta", "feature"], ["!=", "mode", "static"]],
    layout: {
      "text-field": "\uE882",
      "text-size": ["interpolate", ["linear"], ["zoom"], 12, 0, 18, 22],
      "text-allow-overlap": true,
      "text-ignore-placement": true,
      "text-padding": 0,
      "text-line-height": -0.45,
      "text-anchor": "bottom",
      "text-rotate": 0.01,
      "text-justify": "center",
      "text-font": ["fontello Regular"],
    },
    paint: {
      "text-halo-color": "rgba(255, 255, 255, 1)",
      "text-halo-width": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 2],
      "text-translate": [-0.6, 0.1],
      "text-color": "rgba(237, 28, 36, 1)",
      "text-opacity": ["case", ["==", ["get", "user_Tier"], "DROP"], 1, 0],
    },
  },
  // Note that this style is nearly identical to the one above it, but in order
  // to maintain stacking order while drawing (e.g. Distribution hubs on top) we
  // need to have separate styles.
  {
    id: "gl-draw-point-distribution-hub",
    type: "symbol",
    filter: ["all", ["==", "$type", "Point"], ["==", "meta", "feature"], ["!=", "mode", "static"]],
    layout: {
      "text-field": "\uE882",
      "text-size": ["interpolate", ["linear"], ["zoom"], 12, 0, 18, 22],
      "text-allow-overlap": true,
      "text-ignore-placement": true,
      "text-padding": 0,
      "text-line-height": -0.45,
      "text-anchor": "bottom",
      "text-rotate": 0.01,
      "text-justify": "center",
      "text-font": ["fontello Regular"],
    },
    paint: {
      "text-halo-color": "rgba(255, 255, 255, 1)",
      "text-halo-width": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 2],
      "text-translate": [-0.6, 0.1],
      "text-color": "rgba(85, 206, 76, 1)",
      "text-opacity": ["case", ["==", ["get", "user_Tier"], "DISTRIBUTION"], 1, 0],
    },
  },
  {
    id: "gl-draw-point-hover-active",
    type: "circle",
    filter: ["all", ["==", "$type", "Point"], ["==", "meta", "feature"], ["!=", "mode", "static"]],
    paint: {
      "circle-color": "#BBD5ED",
      "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 5],
      "circle-opacity": ["case", ["==", ["get", "user_meta:hover"], "true"], 1, 0],
      "circle-stroke-width": ["case", ["==", ["get", "user_meta:hover"], "true"], 2, 0],
      "circle-stroke-color": "#8BA2B7",
    },
  },
];

export default styles;
